"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Bell = function Bell(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.6015625,12.9296875 C18.2005206,13.5286456 18.5,14.1927081 18.5,14.921875 C18.5,15.625 18.2460938,16.2304688 17.7382812,16.7382812 C17.2304688,17.2460938 16.6119794,17.5 15.8828125,17.5 L12.25,17.5 C12.25,18.203125 12.0091144,18.7955731 11.5273438,19.2773438 C11.0455731,19.7591144 10.453125,20 9.75,20 C9.046875,20 8.45442688,19.7591144 7.97265625,19.2773438 C7.49088562,18.7955731 7.25,18.203125 7.25,17.5 L3.6171875,17.5 C2.88802063,17.5 2.26953125,17.2460938 1.76171875,16.7382812 C1.25390625,16.2304688 1,15.625 1,14.921875 C1,14.1927081 1.29947937,13.5286456 1.8984375,12.9296875 C2.18489563,12.6432294 2.39322937,12.3958331 2.5234375,12.1875 C2.7578125,11.8229169 2.92708313,11.3802081 3.03125,10.859375 C3.16145813,10.2083331 3.2265625,9.38802063 3.2265625,8.3984375 C3.2265625,7.33072937 3.46744812,6.33463562 3.94921875,5.41015625 C4.43098938,4.48567688 5.08854187,3.71744812 5.921875,3.10546875 C6.75520813,2.49348938 7.69270813,2.109375 8.734375,1.953125 C8.578125,1.74479187 8.5,1.51041687 8.5,1.25 C8.5,0.911458135 8.62369812,0.618489385 8.87109375,0.37109375 C9.11848938,0.123698115 9.41145813,0 9.75,0 C10.0885419,0 10.3815106,0.123698115 10.6289062,0.37109375 C10.8763019,0.618489385 11,0.911458135 11,1.25 C11,1.51041687 10.921875,1.74479187 10.765625,1.953125 C11.8072919,2.109375 12.7447919,2.49348938 13.578125,3.10546875 C14.4114581,3.71744812 15.0690106,4.48567688 15.5507812,5.41015625 C16.0325519,6.33463562 16.2734375,7.33072937 16.2734375,8.3984375 C16.2734375,9.38802063 16.3385419,10.2083331 16.46875,10.859375 C16.5729169,11.3802081 16.7421875,11.8229169 16.9765625,12.1875 C17.1067706,12.3958331 17.3151044,12.6432294 17.6015625,12.9296875 Z M9.75,18.4375 C10.0104169,18.4375 10.2317706,18.3463544 10.4140625,18.1640625 C10.5963544,17.9817706 10.6875,17.7604169 10.6875,17.5 L8.8125,17.5 C8.8125,17.7604169 8.90364563,17.9817706 9.0859375,18.1640625 C9.26822937,18.3463544 9.48958313,18.4375 9.75,18.4375 Z M15.8828125,15.625 C16.2213544,15.625 16.4492188,15.4752606 16.5664062,15.1757812 C16.6835938,14.8763019 16.625,14.609375 16.390625,14.375 C15.9479169,13.90625 15.609375,13.5026044 15.375,13.1640625 C15.0625,12.6692706 14.828125,12.0833331 14.671875,11.40625 C14.4895831,10.5989581 14.3984375,9.59635437 14.3984375,8.3984375 C14.3984375,7.56510437 14.1901044,6.79036438 13.7734375,6.07421875 C13.3567706,5.35807312 12.7903644,4.79166687 12.0742188,4.375 C11.3580731,3.95833313 10.5833331,3.75 9.75,3.75 C8.91666687,3.75 8.14192688,3.95833313 7.42578125,4.375 C6.70963562,4.79166687 6.14322937,5.35807312 5.7265625,6.07421875 C5.30989563,6.79036438 5.1015625,7.56510437 5.1015625,8.3984375 C5.1015625,9.59635437 5.01041687,10.5859375 4.828125,11.3671875 C4.671875,12.0703125 4.4375,12.6692706 4.125,13.1640625 C3.890625,13.5026044 3.55208313,13.90625 3.109375,14.375 C2.875,14.609375 2.81640625,14.8763019 2.93359375,15.1757812 C3.05078125,15.4752606 3.27864563,15.625 3.6171875,15.625 L15.8828125,15.625 Z",
    id: "bell"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#bell"
  }));
};

var _default = Bell;
exports["default"] = _default;
module.exports = exports["default"];